<template>
  <div class="app-root">
    <Component :is="layout" v-if="routerReady">
      <RouterView />
    </Component>
    <Toast v-if="routerReady" position="top-right" />
    <MobileWarning v-if="routerReady && !route.path.startsWith('/p/')" />
    <StartupScreen v-if="!routerReady || externalRedirect" />
  </div>
</template>

<script setup>
import "primeicons/primeicons.css";
import Toast from "primevue/toast";
import { defineAsyncComponent, watch, computed, onMounted } from "vue";
import { useEventListener } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import MobileWarning from "@/components/MobileWarning.vue";
import StartupScreen from "@/components/StartupScreen.vue";
import { useRouterReady } from "@/composables/useRouterReady.js";
import { externalRedirect } from "@/helpers/externalRedirect.js";
import { useUserStore } from "@/stores/user.store.js";
import { setAppLocale } from "@/helpers/useI18n.js";
import { useRoute } from "vue-router";
import { version as appVersion } from "../package.json";

const i18n = useI18n({ useScope: "global" });
const route = useRoute();
const routerReady = useRouterReady();
const userStore = useUserStore();

useEventListener(window, "pageshow", (event) => {
  if (event.persisted && routerReady.value) externalRedirect.value = null;
});
const Private = defineAsyncComponent(() => import("@/layouts/Private.vue"));
const Public = defineAsyncComponent(() => import("@/layouts/Public.vue"));

const layout = computed(() => (route.meta.private ? Private : Public));

watch(
  () => userStore.language,
  async (newLanguage) => {
    if (newLanguage) {
      const normalized = await setAppLocale(i18n, newLanguage);
      localStorage.setItem("language", normalized);
    }
  },
  { immediate: true },
);

onMounted(() => console.log(`Currently running Dubrink ${appVersion}`));
</script>
